import SearchPage from '@/views/app/search-page/search-page.view'
import DefaultGuards from '@/guards/default.guards'
import multiguard from 'vue-router-multiguard'

export default [{
  path: 'search',
  name: 'Búsqueda',
  component: SearchPage,
  meta: {
    breadcrumb: 'Búsqueda',
    title: 'Búsqueda',
    colorHeader: '#E64858',
    top: 0,
    position: 'fixed',
    height: 30
  },
  beforeEnter: multiguard([
    DefaultGuards.onQuery('events', {limit: 1000, with: 'category'})
    // DefaultGuards.onQuery('eventArtist', {limit: 1000}),
    // DefaultGuards.onQuery('artistCategories', {limit: 1000}),
    // DefaultGuards.onQuery('eventCategories', {limit: 1000}),
    // DefaultGuards.onQuery('presentations'),
    // DefaultGuards.onQuery('venues', {limit: 1000})
  ])
}]



// WEBPACK FOOTER //
// ./src/router/routes/app/search-page/search-page.router.js